export default __webpack_public_path__ + "static/media/gallery-wip-pommel_10.5884918b.jpg";